import { _notify, NotificationType } from "../services/notification.service";

export const isRecaptchaEnabled = process.env.REACT_APP_VERIFY_RECAPTCHA !== "false";

export async function getRecaptchaToken(
  executeRecaptcha: ((action?: string) => Promise<string>) | undefined,
  action: string
): Promise<string | null> {
  if (!isRecaptchaEnabled) {
    return "disabled";
  }

  if (!executeRecaptcha) {
    _notify(
      NotificationType.ERROR,
      "Security verification failed to load. Disable ad blockers and try again."
    );
    return null;
  }

  try {
    return await executeRecaptcha(action);
  } catch {
    _notify(
      NotificationType.ERROR,
      "Security verification failed. Please refresh and try again."
    );
    return null;
  }
}
